import { useCommunityIndicator } from '@client/new/hooks/use-community-indicator';

export const useMarkCommunityVisited = (): void => {
  useCommunityIndicator(true);
};
